import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import { Store } from './helpers';
import AppRoutes from './routes';

function App() {
  return (
    <CookiesProvider>
      <Provider store={Store}>
        <AppRoutes />
      </Provider>
    </CookiesProvider>
  );
}

export default App;
